import { put } from './service'

export const orderPreviews = ({ files, draftId, csrfToken }) => {
  return put(`/turbosquid/products/${draftId}/thumbnails/order_thumbnails`, {
    data: files,
    draft_id: draftId.toString(),
    authenticity_token: csrfToken,
  })
}
